<template>
    <div>
        <button class="default-buttom" :type="buttonType">{{ labelButton }}</button>
    </div>
</template>

<script>
export default {
    name:'BaseButton',
    props: {
        labelButton: {
            type: String,
            required: false,
            default: 'Enviar'
        },
        buttonType: {
            type: String,
            required: false,
            default: 'button'
        }
    }
}
</script>

<style scoped>
    .default-buttom{
        border: none;
        border-bottom: 1px solid #e3e3e3;
        border-radius: 0;
        text-align: center;
        font-size: 1em;
        background-color: #FFF;
        padding: 0 15px;
    }
    .default-buttom:hover{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/blocks/BaseButton.vue